import { XyoWorldMinter, XyoWorldMinterVersion1Wrapper, XyoWorldMinterVersion2Wrapper } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

export interface MinterContextProps {
  minter?: XyoWorldMinter
  minterVersion1?: XyoWorldMinterVersion1Wrapper
  minterVersion2?: XyoWorldMinterVersion2Wrapper
  now?: number
  refresh?: () => Promise<void>
  update?: () => Promise<void>
}

export const MinterContext = createContext<MinterContextProps>({})
